import { AnimateOnScroll } from "./AnimateOnScroll";
import { useContactForm } from "./ContactContext";

export const CTA = () => {
  const { open } = useContactForm();
  return (
    <section className="py-20 px-6 lg:px-8 bg-[#F3F5F9]">
      <div className="max-w-screen-xl mx-auto">
        <AnimateOnScroll direction="up">
          <div className="bg-[#F3F5F9] rounded-2xl overflow-hidden flex flex-col lg:flex-row shadow-sm border border-gray-200">
            {/* Image */}
            <div className="lg:w-1/2 min-h-[280px] lg:min-h-[380px]">
              <img
                src="/images/sec4.webp"
                alt="Self-Service Kiosk"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Content */}
            <div className="lg:w-1/2 flex items-center px-8 lg:px-14 py-12">
              <div>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#111827] leading-tight mb-6">
                  Ready to Automate Your Operation?
                </h2>
                <p className="text-sm sm:text-base text-[#6b7280] leading-relaxed mb-8">
                  Whether you run a car wash, parking lot, retail store,
                  or credit union — we'll help you find the right kiosk and get it deployed fast.
                </p>
                <button
                  type="button"
                  onClick={() => open({ intent: "contact", source: "Book a Free Consultation" })}
                  className="inline-flex items-center justify-center bg-[#1a1f6c] text-white font-medium rounded-lg px-7 py-3 hover:bg-[#2832c2] transition-colors duration-300"
                >
                  Book a Free Consultation
                </button>
              </div>
            </div>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};
